import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import functions from './functions'
import Variable from './variable'
import './plugins'
import axios from 'axios'
import AOS from 'aos'
import VueSocialSharing from 'vue-social-sharing'
import 'aos/dist/aos.css'
import VueTheMask from 'vue-the-mask';
// Format Money
import Money from 'v-money'
// Format Vuetify Money
import "./plugins/vuetify-money.js"
// WysiWyg
import Wysywig from 'vue-quill-editor'
import Flipbook from 'flipbook-vue'
// Moment JS
import moment from 'moment'
import ComboBox from '@/components/com_combobox.vue'
import Profile from '@/components/com_profile.vue'
import User from '@/components/com_users.vue'
import SuretyShipInquiry from '@/components/com_suretyship_inquiry.vue'
import SuretyShipCreate from '@/components/com_suretyship_create.vue'
import PgdPegasus from '@/components/pgd/com_pgdpegasus.vue'
import PgdDashboard from '@/components/pgd/com_pgddashboard.vue'
import PgdCalculator from '@/components/pgd/com_pgdcalculator.vue'
import PgdEpolis from '@/components/pgd/com_pgdepolis.vue'
import PgdClaim from '@/components/pgd/com_pgdclaim.vue'
import PgdInquiry from '@/components/pgd/com_pgdinquiry.vue'
import VueDropzone from 'vue2-dropzone'
import ToolbarCustom from '@/components/ToolbarCustom.vue'
import DialogLoading from '@/components/DialogLoading.vue'
import DialogNotification from '@/components/DialogNotification.vue'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
// Google Translator
import VueGoogleTranslate from 'vue-google-translate'
import 'regenerator-runtime/runtime'

const apps = {
  install () {
    Vue.vars = Variable
    Vue.prototype.$vars = Variable
  }
}
Vue.prototype.$moment = moment
Vue.prototype.$axios = axios
const plugins = {
  install () {
    Vue.functions = functions
    Vue.prototype.$functions = functions
  }
}
Vue.use(apps)
// Editor Wysywig
Vue.use(plugins)
Vue.use(VueSocialSharing)
// Format Money
Vue.use(Money)
// Vue.use(Flipbook)
Vue.use(VueTheMask)
// Editor Wysywig
Vue.use(Wysywig)
// Plugin Google Translator
Vue.use(VueGoogleTranslate)

// component
Vue.component('app-cb',ComboBox)
Vue.component('app-profile',Profile)
Vue.component('app-pgdpegasus',PgdPegasus)
Vue.component('app-pgddashboard',PgdDashboard)
Vue.component('app-pgdcalculator',PgdCalculator)
Vue.component('app-pgdepolis',PgdEpolis)
Vue.component('app-pgdclaim',PgdClaim)
Vue.component('app-pgdinquiry',PgdInquiry)
Vue.component('app-users',User)
Vue.component('vue-dropzone',VueDropzone)
Vue.component('app-toolbarcustom',ToolbarCustom)
Vue.component('app-dialogloading',DialogLoading)
Vue.component('app-dialognotification',DialogNotification)
Vue.component('app-surety-create',SuretyShipCreate)
Vue.component('app-surety-inqury',SuretyShipInquiry)
Vue.component('flipbook', Flipbook)
Vue.config.productionTip = false
require('../src/styles/my.css')

new Vue({
  router,
  vuetify,
  created () {
    AOS.init()
  },
  render: h => h(App),
}).$mount('#app')
